module.exports = __webpack_public_path__ + "r-v3/img/control_more.7455381c.svg";